import React, { useCallback } from 'react'
import PropTypes from 'prop-types'
import { components } from 'react-select'

const SelectAllMenuList = props => {
  const { selectProps, children } = props
  const { inputValue, getSelectAllCounts, onSelectAll, onDeselectAll } = selectProps
  const counts = getSelectAllCounts(inputValue)

  const handleSelectAll = useCallback(event => {
    event.preventDefault()
    event.stopPropagation()
    onSelectAll(inputValue)
  }, [onSelectAll, inputValue])

  const handleDeselectAll = useCallback(event => {
    event.preventDefault()
    event.stopPropagation()
    onDeselectAll(inputValue)
  }, [onDeselectAll, inputValue])

  return (
    <components.MenuList {...props}>
      <div
        className="bs-actionsbox"
        style={{ position: 'sticky', top: 0, zIndex: 1, background: 'white' }}
      >
        <div className="btn-group btn-group-sm btn-block">
          <button
            className="actions-btn bs-select-all btn btn-light"
            type="button"
            onMouseDown={handleSelectAll}
          >
            {`Tout sélectionner (${counts.selectable})`}
          </button>
          <button
            className="actions-btn bs-deselect-all btn btn-light"
            type="button"
            onMouseDown={handleDeselectAll}
          >
            {`Tout désélectionner (${counts.deselectable})`}
          </button>
        </div>
      </div>
      {children}
    </components.MenuList>
  )
}

SelectAllMenuList.propTypes = {
  children: PropTypes.node.isRequired,
  selectProps: PropTypes.shape({
    getSelectAllCounts: PropTypes.func.isRequired,
    inputValue: PropTypes.string,
    onDeselectAll: PropTypes.func.isRequired,
    onSelectAll: PropTypes.func.isRequired
  }).isRequired
}

export default SelectAllMenuList
